import React from 'react';
import { Shield } from 'lucide-react';

export default function Privacy() {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <div className="p-3 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl shadow-lg shadow-yellow-400/20">
            <Shield className="w-6 h-6 text-gray-900" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-white">Gizlilik Politikası</h1>
            <p className="text-gray-400 mt-1">Son güncelleme: 1 Mart 2024</p>
          </div>
        </div>

        {/* Content */}
        <div className="prose prose-invert max-w-none">
          <div className="space-y-8">
            <section className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <h2 className="text-xl font-semibold text-white mb-4">1. Genel Bilgiler</h2>
              <p className="text-gray-400">
                Bu gizlilik politikası, En Yakın Taksi ("biz", "bizim" veya "şirket") tarafından 
                www.enyakintaksi.app web sitesi ve mobil uygulaması üzerinden toplanan bilgilerin 
                nasıl kullanıldığını, korunduğunu ve paylaşıldığını açıklar.
              </p>
            </section>

            <section className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <h2 className="text-xl font-semibold text-white mb-4">2. Toplanan Bilgiler</h2>
              <p className="text-gray-400 mb-4">
                1. Genel Bilgiler
Bu gizlilik politikası, En Yakın Taksi (“biz”, “bizim” veya “platform”) tarafından sunulan hizmetlerin kullanımında geçerlidir. www.enyakintaksi.app web sitesi ve mobil platformu üzerinden hiçbir kullanıcı verisini saklamıyor, işlemiyor veya üçüncü taraflarla paylaşmıyoruz. Kullanıcılarımızın gizliliği bizim için en önemli önceliktir.
              </p>
              
            </section>

            <section className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <h2 className="text-xl font-semibold text-white mb-4">3. Bilgilerin Kullanımı</h2>
              <p className="text-gray-400 mb-4">
                2. Kişisel Veri İşlenmez
Bizimle iletişime geçmediğiniz sürece herhangi bir kişisel bilgiyi toplamaz veya saklamayız. En Yakın Taksi, sadece kullanıcıların talep ettiği şekilde ve anlık olarak en yakın taksi duraklarını listelemek için çalışır.
	•	Konum Bilgileri: Uygulamamız, yalnızca sizin talebiniz doğrultusunda cihazınızdaki konum servislerini kullanarak en yakın taksileri bulur. Ancak bu konum verileri kaydedilmez veya saklanmaz.
	•	Hesap Bilgileri: Herhangi bir kullanıcı kaydı veya hesap oluşturma işlemi gerektirmez.
	•	Çerezler & İzleme: Web sitemizde çerezler (cookies) kullanılmamaktadır. Tarayıcınızda favori durak eklediğiniz taktirde cache bırakır ve belirlediğiniz durağı sürekli kolayca ulaşabilmeniz içindir.
              </p>
          
            </section>

            <section className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <h2 className="text-xl font-semibold text-white mb-4">4. Bilgilerin Paylaşımı</h2>
              <p className="text-gray-400">
                Kullanıcılarımızın gizliliğini korumak için hiçbir kullanıcı verisini üçüncü taraflarla paylaşmıyoruz. Tüm işlemler cihazınızda çalışır ve harici bir sunucuya veri iletilmez.
	•	Hiçbir kişisel veri saklanmaz veya işlenmez.
	•	Konum bilgileriniz, sadece size en yakın taksi duraklarını göstermek amacıyla cihazınız tarafından geçici olarak kullanılır.
              </p>
            </section>

            <section className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <h2 className="text-xl font-semibold text-white mb-4">5. Güvenlik</h2>
              <p className="text-gray-400">
                En Yakın Taksi, tamamen kullanıcı odaklı ve güvenli bir sistem üzerine kurulmuştur.
	•	Hiçbir kişisel veri veritabanımızda tutulmaz.
	•	Konum bilgileri, yalnızca cihazınız üzerinden geçici olarak kullanılır ve saklanmaz.
	•	Platformumuzda güvenliği sağlamak için hiçbir kişisel bilgi talep etmiyoruz.
              </p>
            </section>

            <section className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <h2 className="text-xl font-semibold text-white mb-4">6. Çerezler</h2>
              <p className="text-gray-400">
                Web sitemizde çerezler kullanılmaktadır. Çerezler, kullanıcı deneyimini 
                iyileştirmek ve site kullanımını analiz etmek için kullanılır.
              </p>
            </section>

            <section className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-white/5">
              <h2 className="text-xl font-semibold text-white mb-4">7. İletişim</h2>
              <p className="text-gray-400">
                İletişim
Eğer En Yakın Taksi platformunun gizlilik politikasıyla ilgili herhangi bir sorunuz varsa, bizimle aşağıdaki e-posta adresi üzerinden iletişime geçebilirsiniz:

📩 info@enyakintaksi.app
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}